//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import headTop from '../../components/headTop'
export default {
    components: {
        headTop
    },
    data () {
        return {
            title:"再传佳讯！摩尔入选工信部“2019年工业互联网APP优秀解决方案",
            date:"2020-06-09",
            time:"12:10:10",
            content:"近日，国家工信部公布了2019年工业互联网APP优秀解决方案名单，摩尔元数（厦门）科技有申报的“摩尔云生产APP应用解决方案”成功入选。据悉，此次评选根据《工业互联网APP培育工程实施方案（2018-2020年）》（工信部信软〔2018〕79号）要求，主要面向国内制造业重要装备研制需求、“工业四基”领域、行业通用需求和制造企业个性化需求等四个重点方向，经地方（行业）推荐、形式审查和专家评审等环节，最终遴选出125个工业互联网APP优秀解决方案。旨在加强典型经验总结和优秀案例推广，推动工业互联网APP生态建设。摩尔申报的“摩尔云生产APP应用解决方案”是摩尔自主研发，面向企业的信息化管理平台，以生产过程的管理为核心，在帮助制造企业提质增效、转型升级方面发挥了显著的支撑引领作用，在制造企业中应用效果突出。",
            preTXT:"摩尔荣获2019年度中国工业互联网优秀供年度中国工业互联网优秀供",
            nextTXT:"摩尔荣获2019年度中国工业互联网优秀供年度中国工业互联网优秀供",
            comlist:[{
                title:"N2云智造小课堂——葡萄图考核"
            },{
                title:"喜报！摩尔入选福建省第一批工业互联网示范平台"
            },{
                title:"摩尔专家面谈，疫情下的制造企业的复工复产之路"
            },{
                title:"摩尔荣获2019年度中国工业互联网优秀供应商"
            },{
                title: "摩尔官网全新改版，手机端同步上线，等你来体验！"
            }],
            newsId:"",
            pageModel:{pageSize:0},
            model:"",
            typeId:"",
            upModel:"",
            downModel:"",
            relatedNewsList:{},
            typeName:"",
            typeList:"",
        }
    },
     created(){
        this.newsId=this.$route.query.newsId
        this.typeId=this.$route.query.typeId
        this.typeName=this.$route.query.typeName
        console.log(this.newsId)
        this.init()
    },
    methods: {
          init(){
            this.pageModel.newsId=this.newsId;
            this.pageModel.typeId=this.typeId;
            this.$http.post(this.global.httpUrl + '/rest/v1/m/mindex/getArticleDetail',this.pageModel,{emulateJSON:true}).then(function(res){
                    if(res.body.success)
                    {
                      console.log(res.body)
                      this.model=res.body.model
                      if(res.body.upModel){
                        this.upModel=res.body.upModel
                      }
                     if(res.body.downModel){
                        this.downModel=res.body.downModel
                      }
                      this.relatedNewsList=res.body.relatedNewsList

                      if(res.body.typeList){
                          this.typeList=res.body.typeList
                      }
                    }
                },function(res){
            });
        },
        detail(newsId){
             window.location.href = "/consult/consultdetail?newsId="+newsId+"&typeId="+this.typeId+"&typeName="+this.typeName
       },
       goRecommend(newsId,typeId){
            var typeName
           for(var i=0;i<this.typeList.length;i++){
               if(typeId==this.typeList[i].typeId){
                    typeName=this.typeList[i].typeName
               }
           }
           window.location.href = "/consult/consultdetail?newsId="+newsId+"&typeId="+typeId+"&typeName="+typeName
       }
    }
}



// WEBPACK FOOTER //
// ./src/views/consult/sharedetail.vue